exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-plug[data-v-8196854c] {\n  height: 100%;\n}\n.app-plug .header[data-v-8196854c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.app-plug .start-test[data-v-8196854c] {\n  margin-right: 10px;\n}", ""]);

// exports
